import { request } from "./request";
import { getPharmacyPayload, ListPharmacyPayload, ListPharmacyReturn, PharmacyInfo } from "@/api/types";

export async function getPharmacy(payload: getPharmacyPayload): Promise<PharmacyInfo> {
  return await request<PharmacyInfo>({
    url: "/pharmacy/get",
    method: "POST",
    data: payload,
  });
}
export async function getPharmacies(payload: ListPharmacyPayload): Promise<ListPharmacyReturn> {
  return await request<ListPharmacyReturn>({
    url: "/premium/pharmacy/list",
    method: "POST",
    data: payload,
  });
}
